import {NgModule, ErrorHandler} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicApp, IonicModule} from 'ionic-angular';
import {MyApp} from './app.component';
import {CvSubmitPage} from "../pages/cv-submit/cv-submit.page";
import {JobPage} from "../pages/job/job.page";
import {JobsPage} from "../pages/jobs/jobs.page";
import {EmptyState} from "../pages/jobs-list/shared/empty-state/empty-state.component";
import {LoginPage} from "../pages/login/login.page";
import {ProfilePage} from "../pages/profile/profile.page";
import {SignupPage} from "../pages/signup/signup.page";
import {JobTimeModal} from "./components/job-time-modal/job-time-modal.component";
import {LanguagePickerComponent} from "./components/language-picker/language-picker.component";
import {LoadingBar, LoadingBarBackendFactory} from "./components/loading-bar/loading-bar";
import {PlacesSearchModal} from "./components/places-search-modal/places-search-modal.component";
import {PricingModal} from "./components/pricing-modal/pricing-modal.component";
import {TimezonePickerComponent} from "./components/timezone-picker/timezone-picker.component";
import {UploaderComponent} from "./components/uploader/uploader.component";
import {AppVersionComponent} from "./components/app-version.component";
import {JobAttachmentsComponent} from "./components/uploader/job-attachments/job-attachments.component";
import {JobsListComponent} from "../pages/jobs-list/shared/jobs-list.component";
import {LocaleService} from "./components/language-picker/locale.service";
import {TimezoneService} from "./components/timezone-picker/timezone.service";
import {TranslateService, TranslateModule, TranslateLoader} from "@ngx-translate/core";
import {PushService} from "./core/push.service";
import {ToastService} from "./core/toast.service";
import {DeviceService} from "./core/device.service";
import {AppAuth} from "./core/auth";
import {HttpModule, XHRBackend, BrowserXhr, ResponseOptions, XSRFStrategy, Http, RequestOptions} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {MomentPipe} from "./core/moment.pipe";
import {FileUploadModule} from "ng2-file-upload";
import {MyHttp} from "./core/http";
import {JobService} from "../pages/job/shared/job.service";
import {LanguageService} from "../pages/shared/language/language.service";
import {AppErrorHandler} from "./core/error-handler";
import {ProfileService} from "../pages/profile/profile.service";
import {JobTypeService} from "../pages/shared/job-type/job-type.service";
import {UploadService} from "./components/uploader/upload.service";
import {ReferClientFormComponent} from "./components/refer-client-form/refer-client-form.component";
import {UserService} from "../pages/shared/user/user.service";
import {IonicStorageModule, Storage} from "@ionic/storage";
import {VideoService} from "./components/video/video.service";
import {VideoLinkComponent} from "./components/video/video-link.component";
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {AppVersion} from "@ionic-native/app-version";
import {Device} from "@ionic-native/device";
import {Toast} from "@ionic-native/toast";
import {OneSignal} from "@ionic-native/onesignal";
import {AuthConfig, JwtHelper} from "angular2-jwt";
import {JobsListPage} from "../pages/jobs-list/jobs-list.page";
import {EnvironmentComponent} from "./components/environment.component";
import {CountryCodesService} from "../pages/shared/country-codes.service";
import {JobActivityComponent} from "../pages/job/job-activity/job-activity.component";
import {VideoMeetingComponent} from "./components/video/video-meeting.component";
import {RoleService} from "./core/role.service";
import {InterpreterSignupComponent} from "../pages/signup/interpreter-signup/interpreter-signup.component";
import {ClientSignupComponent} from "../pages/signup/client-signup/client-signup.component";
import {OrganisationService} from "../pages/signup/interpreter-signup/organisation.service";
import {OrganisationSearchModal} from "./components/organisation-search-modal/organisation-search-modal.component";
import {ClientJobsFiltersComponent} from "../pages/jobs-list/shared/client-jobs-filters/client-jobs-filters.component";
import {InterpreterJobDetailsComponent} from "../pages/job/interpreter-job-details/interpreter-job-details.component";
import {ClientJobDetailsComponent} from "../pages/job/client-job-details/client-job-details.component";
import {JobEditFormComponent} from "../pages/job/job-edit-form/job-edit-form.component";
import {InterpreterSearchModal} from "./components/interpreter-search-modal/interpreter-search-modal.component";
import {JobDetailsHeaderComponent} from "../pages/job/job-details-header/job-details-header.component";
import {JobControlsComponent} from "../pages/job/job-controls/job-controls.component";
import {JobMenuComponent} from "../pages/job/job-menu/job-menu.component";
import {InterpreterProfileComponent} from "../pages/profile/interpreter-profile/interpreter-profile.component";
import {ClientProfileComponent} from "../pages/profile/client-profile/client-profile.component";
import {MenuComponent} from "./components/menu/menu.component";
import {JobControlsService} from "../pages/job/job-controls/job-controls.service";
import {JobMenuService} from "../pages/job/job-menu/job-menu.service";
import {UsersPage} from "../pages/users/users.page";
import {ContractService} from "./core/contract.service";
import {ContractModal} from "./components/contract-modal/contract-modal.component";
import {SafeHtmlPipe} from "./core/safe-html.pipe";
import {SignaturePadModule} from "angular2-signaturepad";
import {RatingModal} from "./components/rating-modal/rating-modal.component";
import {NotificationService} from "../pages/profile/notification.service";
import {LegalItemsComponent} from "../pages/profile/legal-items/legal-items.component";
import {NotificationsItemsComponent} from "../pages/profile/notifications-items/notifications-items.component";
import {ColleagueSearchModal} from "./components/colleague-search-modal/colleague-search-modal.component";
import {JobSignaturesComponent} from "../pages/job/job-signatures/job-signatures.component";
import {SpecialityService} from "../pages/shared/specialities/speciality.service";
import {SpecialitiesSelectModal} from "./components/specialities-select-modal/specialities-select-modal.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/locale/', '.json');
}

export const storage = new Storage({});

export const AUTH_TOKEN_NAME = 'ng2-ui-auth_tolkify_app_auth_token';

export function MyHttpFactory(locale: LocaleService,
                              http: Http,
                              options?: RequestOptions) {
  return new MyHttp(locale, new AuthConfig({
    noJwtError: true,
    globalHeaders: [{'Accept': 'application/json, text/plain, */*'}, {'Content-Type' : 'application/json'}],
    tokenGetter: (() => storage.ready().then(() => storage.get(AUTH_TOKEN_NAME)).then((token: string) => token))
  }), http, options);
}

@NgModule({
  declarations: [
    MyApp,
    CvSubmitPage,
    JobPage,
    JobsPage,
    JobsListPage,
    EmptyState,
    LoginPage,
    ProfilePage,
    SignupPage,
    UsersPage,
    InterpreterSignupComponent,
    ClientSignupComponent,
    JobTimeModal,
    ContractModal,
    LanguagePickerComponent,
    TimezonePickerComponent,
    LoadingBar,
    PlacesSearchModal,
    OrganisationSearchModal,
    InterpreterSearchModal,
    ColleagueSearchModal,
    PricingModal,
    RatingModal,
    SpecialitiesSelectModal,
    UploaderComponent,
    AppVersionComponent,
    EnvironmentComponent,
    ClientJobsFiltersComponent,
    InterpreterJobDetailsComponent,
    ClientJobDetailsComponent,
    JobEditFormComponent,
    JobAttachmentsComponent,
    JobsListComponent,
    MomentPipe,
    SafeHtmlPipe,
    ReferClientFormComponent,
    VideoLinkComponent,
    VideoMeetingComponent,
    JobActivityComponent,
    JobSignaturesComponent,
    JobDetailsHeaderComponent,
    JobControlsComponent,
    JobMenuComponent,
    MenuComponent,
    InterpreterProfileComponent,
    ClientProfileComponent,
    LegalItemsComponent,
    NotificationsItemsComponent
  ],
  imports: [
    IonicModule.forRoot(MyApp/*, {
      platforms: {
        ios: {
          statusbarPadding: true // Hackfix as on some iOS devices it's not applied O.o
        }
      }
    }*/),
    IonicStorageModule.forRoot(),
    FileUploadModule,
    BrowserModule,
    HttpModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SignaturePadModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    PlacesSearchModal,
    OrganisationSearchModal,
    InterpreterSearchModal,
    ColleagueSearchModal,
    SpecialitiesSelectModal,
    JobTimeModal,
    PricingModal,
    ContractModal,
    RatingModal,
    CvSubmitPage,
    JobPage,
    JobsPage,
    JobsListPage,
    LoginPage,
    ProfilePage,
    SignupPage,
    UsersPage,
    JobMenuComponent,
    MenuComponent
  ],
  providers: [
    {
      provide: ErrorHandler, useClass: AppErrorHandler
    },
    {
      provide: MyHttp,
      useFactory: MyHttpFactory,
      deps: [LocaleService, Http, RequestOptions],
    },
    {
      provide: XHRBackend,
      useFactory: LoadingBarBackendFactory,
      deps: [BrowserXhr, ResponseOptions, XSRFStrategy]
    },
    LocaleService,
    TimezoneService,
    TranslateService,
    LanguageService,
    PushService,
    JobService,
    ToastService,
    DeviceService,
    UserService,
    AppAuth,
    ProfileService,
    JobTypeService,
    UploadService,
    VideoService,
    StatusBar,
    SplashScreen,
    AppVersion,
    Device,
    Toast,
    OneSignal,
    JwtHelper,
    CountryCodesService,
    RoleService,
    OrganisationService,
    JobControlsService,
    JobMenuService,
    ContractService,
    NotificationService,
    SpecialityService
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts